// packages/eden-style-constants/src/index.js
import { setAppearanceConstantGlobal } from "./modes";
import {
  setAppearanceConstant,
  getAppearanceConstant,
  setAppearanceConstantLocal
} from "./modes";
var grey2 = "#f7f8f8";
var grey3 = "#eff0f0";
var grey5 = "#e0e2e2";
var grey10 = "#d0d3d3";
var grey15 = "#bdc0c0";
var grey20 = "#a9adad";
var grey25 = "#9da1a1";
var grey30 = "#878a8c";
var grey35 = "#676b6e";
var grey40 = "#53575b";
var grey60 = "#3a3d40";
var grey90 = "#0D0F10";
var yellow5 = "#ffd61a";
var yellow10 = "#ffb81c";
var yellow15 = "#faa61a";
var yellow20 = "#f68d2e";
var yellow25 = "#e66a1f";
var yellow30 = "#d45311";
var yellow35 = "#974a07";
var yellow40 = "#674730";
var red5 = "#fda1b2";
var red10 = setAppearanceConstantGlobal("red10", {
  light: "#fc4e6d",
  dark: "#FF7591"
});
var red15 = setAppearanceConstantGlobal("red15", {
  light: "#e10f5a",
  dark: "#ED3A65"
});
var red20 = "#bd0057";
var red25 = "#a6004e";
var red30 = "#8f124a";
var red35 = "#7d003f";
var red40 = "#6e0d33";
var blue5 = "#b0eefc";
var blue10 = "#7de3f4";
var blue15 = "#49cce6";
var blue20 = "#01b6d1";
var blue25 = "#007da5";
var blue30 = "#006184";
var blue35 = "#005175";
var blue40 = "#003057";
var green5 = "#d3e952";
var green10 = "#bed21e";
var green15 = "#93c742";
var green20 = "#6db344";
var green25 = "#50a83e";
var green30 = "#318d43";
var green35 = "#206b3f";
var green40 = "#235c35";
var text120 = "#212225";
var black = "#000000";
var white = "#ffffff";
var colorFacebook = "#3b5998";
var colorInstagram = "#3c5a96";
var colorPinterest = "#cb2027";
var colorYoutube = "#cd201f";
var colorOdnok = "#ed812b";
var colorVk = "#45668e";
var sans = `"Ensign:Sans", Roboto, Arial, sans-serif`;
var serif = `"Ensign:Serif", "Noto Serif", Georgia, serif`;
var monospace = `Courier, "Courier New", monospace`;
var fontWeightLight = 300;
var fontWeightNormal = 400;
var fontWeightSemiBold = 600;
var fontWeightBold = 700;
var fontSizeRoot = `100%`;
var fontSize11 = "0.6875rem";
var fontSize13 = "0.8125rem";
var fontSize14 = "0.875rem";
var fontSize16 = "1rem";
var fontSize18 = "1.125rem";
var fontSize20 = "1.25rem";
var fontSize28 = "1.75rem";
var fontSize32 = "2rem";
var fontSize42 = "2.625rem";
var lineHeightTight = 1.2;
var lineHeight = 1.4;
var lineHeightLoose = 1.6;
var spacing4 = "0.25rem";
var spacing8 = "0.5rem";
var spacing16 = "1rem";
var spacing24 = "1.5rem";
var spacing32 = "2rem";
var spacing48 = "3rem";
var spacing64 = "4rem";
var spacing96 = "6rem";
var spacing128 = "8rem";
var breakWidth480 = "480px";
var breakWidth600 = "600px";
var breakWidth840 = "840px";
var breakWidth960 = "960px";
var breakWidth1280 = "1280px";
var breakWidth1440 = "1440px";
var breakWidth1600 = "1600px";
var aspectRatio1By1 = { width: 1, height: 1, key: "1:1" };
var aspectRatio5By6 = { width: 5, height: 6, key: "5:6" };
var aspectRatio5By8 = { width: 5, height: 8, key: "5:8" };
var aspectRatio6By5 = { width: 6, height: 5, key: "6:5" };
var aspectRatio8By3 = { width: 8, height: 3, key: "8:3" };
var aspectRatio8By5 = { width: 8, height: 5, key: "8:5" };
var aspectRatio16By9 = { width: 16, height: 9, key: "16:9" };
var aspectRatios = [
  aspectRatio1By1,
  aspectRatio5By6,
  aspectRatio5By8,
  aspectRatio6By5,
  aspectRatio8By3,
  aspectRatio8By5,
  aspectRatio16By9
];
var zIndexHigherThanPlatform = 200;
var borderRadius = "0.125rem";
var whiteTransparency10 = "#FFFFFFDE";
var whiteTransparency20 = "#FFFFFF99";
var whiteTransparency30 = "#FFFFFF61";
var whiteTransparency40 = "#FFFFFF3D";
var whiteTransparency50 = "#FFFFFF33";
var whiteTransparency60 = "#FFFFFF29";
var whiteTransparency70 = "#FFFFFF1F";
var whiteTransparency80 = "#FFFFFF14";
var backgroundColorAlt = setAppearanceConstantGlobal(
  "background-color-alt",
  {
    light: grey3,
    dark: whiteTransparency30
  }
);
var backgroundColorHover = setAppearanceConstantGlobal(
  "background-color-hover",
  {
    light: grey3,
    dark: whiteTransparency60
  }
);
var backgroundColorActive = setAppearanceConstantGlobal(
  "background-color-active",
  {
    light: grey5,
    dark: whiteTransparency40
  }
);
var backgroundColorDisabled = setAppearanceConstantGlobal(
  "background-color-disabled",
  {
    light: grey2,
    dark: whiteTransparency70
  }
);
var backgroundColorLevelCurrent = setAppearanceConstantGlobal(
  "background-color-level-current",
  {
    light: white,
    dark: "#121212"
  }
);
var backgroundColorLevel1 = setAppearanceConstantGlobal(
  "background-color-level1",
  {
    light: white,
    dark: "#121212"
  }
);
var backgroundColorLevel2 = setAppearanceConstantGlobal(
  "background-color-level2",
  {
    light: white,
    // 8% white on #121212
    dark: "#252525"
  }
);
var backgroundColorLevel3 = setAppearanceConstantGlobal(
  "background-color-level3",
  {
    light: white,
    // 11% white on #121212
    dark: "#2c2c2c"
  }
);
var backgroundColorLevel4 = setAppearanceConstantGlobal(
  "background-color-level4",
  {
    light: white,
    // 14% white on #121212
    dark: "#333333"
  }
);
var backgroundColorLevel5 = setAppearanceConstantGlobal(
  "background-color-level5",
  {
    light: white,
    // 16% white on #121212
    dark: "#383838"
  }
);
var textColorPrimary = setAppearanceConstantGlobal(
  "text-color-primary",
  {
    light: text120,
    dark: whiteTransparency10
  }
);
var textColorSecondary = setAppearanceConstantGlobal(
  "text-color-secondary",
  {
    light: grey40,
    dark: whiteTransparency20
  }
);
var textColorTertiary = setAppearanceConstantGlobal(
  "text-color-tertiary",
  {
    light: grey30,
    dark: whiteTransparency30
  }
);
var textColorInverted = setAppearanceConstantGlobal(
  "text-color-inverted",
  {
    light: white,
    dark: black
  }
);
var accentColorLink = setAppearanceConstantGlobal(
  "accent-color-link",
  {
    light: "#157493",
    dark: blue15
  }
);
var accentColorLinkActive = setAppearanceConstantGlobal(
  "accent-color-link-active",
  {
    light: "#b00504",
    dark: "#FF7770"
  }
);
var accentColorLinkVisited = setAppearanceConstantGlobal(
  "accent-color-link-visited",
  {
    light: "#9C4F9C",
    dark: "#C092FC"
  }
);
var accentColorPrimary = setAppearanceConstantGlobal(
  "accent-color-primary",
  {
    light: blue30,
    dark: blue15
  }
);
var accentColorInfo = setAppearanceConstantGlobal(
  "accent-color-info",
  {
    light: blue30,
    dark: blue10
  }
);
var accentColorConfirmation = setAppearanceConstantGlobal(
  "accent-color-confirmation",
  {
    light: green30,
    dark: green10
  }
);
var accentColorWarning = setAppearanceConstantGlobal(
  "accent-color-warning",
  {
    light: yellow30,
    dark: yellow10
  }
);
var accentColorDanger = setAppearanceConstantGlobal(
  "accent-color-danger",
  {
    light: "#b00504",
    dark: "#ff7770"
  }
);
var borderColorPrimary = setAppearanceConstantGlobal(
  "border-color-primary",
  {
    light: grey30,
    dark: whiteTransparency20
  }
);
var borderColorSecondary = setAppearanceConstantGlobal(
  "border-color-secondary",
  {
    light: grey15,
    dark: whiteTransparency30
  }
);
var borderColorTertiary = setAppearanceConstantGlobal(
  "border-color-tertiary",
  {
    light: grey5,
    dark: whiteTransparency70
  }
);
var highlightRed = setAppearanceConstantGlobal("highlight-red", {
  light: "#FE4F6633",
  dark: "#BA505E61"
});
var highlightOrange = setAppearanceConstantGlobal("highlight-orange", {
  light: "#FE98293D",
  dark: "#C68A4E61"
});
var highlightYellow = setAppearanceConstantGlobal("highlight-yellow", {
  light: "#FCDB3B61",
  dark: "#D6BF5961"
});
var highlightGreen = setAppearanceConstantGlobal("highlight-green", {
  light: "#A9D5273D",
  dark: "#8CA05261"
});
var highlightBlue = setAppearanceConstantGlobal("highlight-blue", {
  light: "#10D9E133",
  dark: "#60B5B861"
});
var highlightDarkBlue = setAppearanceConstantGlobal(
  "highlight-darkblue",
  {
    light: "#2596FF29",
    dark: "#5587B561"
  }
);
var highlightPurple = setAppearanceConstantGlobal("highlight-purple", {
  light: "#9D53FE29",
  dark: "#7654A561"
});
var highlightPink = setAppearanceConstantGlobal("highlight-pink", {
  light: "#F85BEA33",
  dark: "#B56BB04D"
});
var highlightBrown = setAppearanceConstantGlobal("highlight-brown", {
  light: "#CD7D5A33",
  dark: "#946D5D61"
});
var highlightGrey = setAppearanceConstantGlobal("highlight-grey", {
  light: "#AEB8C13D",
  dark: "#8E969C61"
});
var boxShadowRaised = setAppearanceConstantGlobal(
  "box-shadow-raised",
  {
    light: "0 2px 4px 0 #00000033",
    // 20%
    dark: "0 2px 4px 0 #00000066"
    // 40%
  }
);
var boxShadowDetached = setAppearanceConstantGlobal(
  "box-shadow-detached",
  {
    light: "0 4px 8px 0 #00000033",
    dark: "0 4px 8px 0 #00000066"
  }
);
var boxShadowOverlaid = setAppearanceConstantGlobal(
  "box-shadow-overlaid",
  {
    light: "0 8px 16px 0 #00000033",
    dark: "0 8px 16px 0 #00000066"
  }
);
var boxShadowPoppedOut = setAppearanceConstantGlobal(
  "box-shadow-popped",
  {
    light: "0 16px 32px 0 #00000033",
    dark: "0 16px 32px 0 #00000066"
  }
);
var colorScheme = setAppearanceConstantGlobal("color-scheme", {
  light: "light",
  dark: "dark"
});
export {
  accentColorConfirmation,
  accentColorDanger,
  accentColorInfo,
  accentColorLink,
  accentColorLinkActive,
  accentColorLinkVisited,
  accentColorPrimary,
  accentColorWarning,
  aspectRatio16By9,
  aspectRatio1By1,
  aspectRatio5By6,
  aspectRatio5By8,
  aspectRatio6By5,
  aspectRatio8By3,
  aspectRatio8By5,
  aspectRatios,
  backgroundColorActive,
  backgroundColorAlt,
  backgroundColorDisabled,
  backgroundColorHover,
  backgroundColorLevel1,
  backgroundColorLevel2,
  backgroundColorLevel3,
  backgroundColorLevel4,
  backgroundColorLevel5,
  backgroundColorLevelCurrent,
  black,
  blue10,
  blue15,
  blue20,
  blue25,
  blue30,
  blue35,
  blue40,
  blue5,
  borderColorPrimary,
  borderColorSecondary,
  borderColorTertiary,
  borderRadius,
  boxShadowDetached,
  boxShadowOverlaid,
  boxShadowPoppedOut,
  boxShadowRaised,
  breakWidth1280,
  breakWidth1440,
  breakWidth1600,
  breakWidth480,
  breakWidth600,
  breakWidth840,
  breakWidth960,
  colorFacebook,
  colorInstagram,
  colorOdnok,
  colorPinterest,
  colorScheme,
  colorVk,
  colorYoutube,
  fontSize11,
  fontSize13,
  fontSize14,
  fontSize16,
  fontSize18,
  fontSize20,
  fontSize28,
  fontSize32,
  fontSize42,
  fontSizeRoot,
  fontWeightBold,
  fontWeightLight,
  fontWeightNormal,
  fontWeightSemiBold,
  getAppearanceConstant,
  green10,
  green15,
  green20,
  green25,
  green30,
  green35,
  green40,
  green5,
  grey10,
  grey15,
  grey2,
  grey20,
  grey25,
  grey3,
  grey30,
  grey35,
  grey40,
  grey5,
  grey60,
  grey90,
  highlightBlue,
  highlightBrown,
  highlightDarkBlue,
  highlightGreen,
  highlightGrey,
  highlightOrange,
  highlightPink,
  highlightPurple,
  highlightRed,
  highlightYellow,
  lineHeight,
  lineHeightLoose,
  lineHeightTight,
  monospace,
  red10,
  red15,
  red20,
  red25,
  red30,
  red35,
  red40,
  red5,
  sans,
  serif,
  setAppearanceConstant,
  setAppearanceConstantLocal,
  spacing128,
  spacing16,
  spacing24,
  spacing32,
  spacing4,
  spacing48,
  spacing64,
  spacing8,
  spacing96,
  text120,
  textColorInverted,
  textColorPrimary,
  textColorSecondary,
  textColorTertiary,
  white,
  whiteTransparency10,
  whiteTransparency20,
  whiteTransparency30,
  whiteTransparency40,
  whiteTransparency50,
  whiteTransparency60,
  whiteTransparency70,
  whiteTransparency80,
  yellow10,
  yellow15,
  yellow20,
  yellow25,
  yellow30,
  yellow35,
  yellow40,
  yellow5,
  zIndexHigherThanPlatform
};
